import { z } from 'zod';
import { UuidSchema, CurrencyCodeSchema, PositiveNumberSchema, DateTimeSchema } from './common.schema';

export const FundingPoolWeightSchema = z.object({
  user_id: UuidSchema,
  weight: z.number().min(0),
  name: z.string().optional().nullable(),
});

export const FundingPoolSchema = z.object({
  id: UuidSchema,
  group_id: UuidSchema,
  name: z.string(),
  currency_code: CurrencyCodeSchema,
  created_at: z.string(),
  created_by: UuidSchema,
  weights: z.array(FundingPoolWeightSchema).default([]),
});

export const FundingPoolsResponseSchema = z.object({
  pools: z.array(FundingPoolSchema),
});

export const PoolInsertRequestSchema = z.object({
  amount: PositiveNumberSchema,
  currency_code: CurrencyCodeSchema,
  description: z.string().optional(),
  inserted_by: UuidSchema.optional(),
  date: DateTimeSchema.optional(),
});

export const PoolInsertResponseSchema = z.object({
  event: z.object({
    id: UuidSchema,
    group_id: UuidSchema,
    pool_id: UuidSchema,
    type: z.enum(['insert', 'funded_expense']),
    amount: z.union([z.number(), z.string()]).transform((value) =>
      typeof value === 'string' ? parseFloat(value) : value
    ),
    currency_code: CurrencyCodeSchema,
    description: z.string().optional().nullable(),
    created_at: z.string(),
    created_by: UuidSchema,
  }),
  adjustments: z.array(z.object({
    from_user_id: UuidSchema,
    to_user_id: UuidSchema,
    amount: z.number(),
  })),
});

export type FundingPool = z.infer<typeof FundingPoolSchema>;
export type PoolInsertRequest = z.infer<typeof PoolInsertRequestSchema>;
export type PoolInsertResponse = z.infer<typeof PoolInsertResponseSchema>;
